import React from 'react'
import VisaPackagesWorker from './visa-packages'
import { Link, withRouter } from 'react-router-dom'
import iconEdit from '../../../assets/icons/edit-black.svg'
import iconDelete from '../../../assets/icons/delete-black.svg'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import NumberFormat from 'react-number-format'

class VisaPackages extends React.Component {

    constructor() {
        super()
        this.visaPackagesWorker = VisaPackagesWorker(this)
        this.state = this.visaPackagesWorker.getDefaultState()
    }

    componentDidMount() {
        this.visaPackagesWorker.loadVisaPackages()
    }

    onDelete = id => this.visaPackagesWorker.deleteVisaPackage(id)

    getStatusLabel = status => {
        switch (Number(status)) {
            case 0:
                return "Draft"
            case 1:
                return "Published"
            case 2:
                return "Archived"
            default:
                return status
        }
    }

    renderFeatures = (features) => {
        if (Array.isArray(features)) {
            return features.join(', ')
        }
        if (typeof features === 'string' && features.length > 0) {
            return features
        }
        return '-'
    }

    render() {
        return (
            <div className="visa-packages">
                {
                    this.state.loading && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/visa-packages/create">New Visa Package</Link>
                    <div className="header">
                        <h4>Visa Packages</h4>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Category</th>
                                <th>Featured</th>
                                <th>Price</th>
                                <th>Features</th>
                                <th>Status</th>
                                <th>Updated</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.visaPackages.map((visaPackage, key) => {
                                    const updatedAt = visaPackage.updatedAt || visaPackage.updated
                                    return (
                                        <tr key={key}>
                                            <td>{visaPackage.name}</td>
                                            <td>{visaPackage.category}</td>
                                            <td>{visaPackage.featured ? 'Yes' : 'No'}</td>
                                            <td>{visaPackage.price == null ? '-' : <NumberFormat value={visaPackage.price} displayType="text" thousandSeparator={true} prefix="₦" />}</td>
                                            <td>{this.renderFeatures(visaPackage.features)}</td>
                                            <td>{this.getStatusLabel(visaPackage.status)}</td>
                                            <td>{updatedAt ? new Date(updatedAt).toLocaleString() : '-'}</td>
                                            <td>
                                                <div className="actions">
                                                    <img alt="" src={iconEdit} onClick={() => this.props.history.push('/content/visa-packages/edit/' + visaPackage.id)} />
                                                    {
                                                        this.state.deletingId === visaPackage.id ? <Loading /> : <img alt="" src={iconDelete} onClick={() => this.onDelete(visaPackage.id)} />
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default withRouter(VisaPackages)
